module.exports = __webpack_public_path__ + "static/media/videoFrame_2.cdf7e057.png";